import React from "react";
import "./footer.css"
import logo from '../logo.png';

function Footer (){
    const scrollTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    };
    return (
        <>
        <div className="container-fluid row g-0 align-items-center" style={{backgroundColor: "#003333"}}>
            <div className="col-md-4 row align-items-center">
                <div className="col-md-3 text-center">
                    <img src={logo} alt="uniski" width="50" height="50" className="d-inline-block align-text-center mx-2"/>
                </div>
                <div className="col-md-9">
                    <h5 style={{color: "#cccccc"}}>S I N E R G I</h5>
                    <h6 style={{color: "#cccccc"}}>Sistem Informasi dan Inventaris Digital</h6>
                </div>
            </div>
            <div className="col-md-4 text-center">
                <button className="border border-0 bg-transparent" style={{color: "#cccccc"}} onClick={scrollTop}>Kembali Keatas <i className="bi bi-arrow-up"style={{color: "#cccccc"}} ></i></button>
            </div>
            
            <div className="col-md-4 text-end">
                <a className="ps-3 set-uniski" href="https://uniski.ac.id/">UNISKI Kayuagung</a>
                <h6 className="set-smaller ps-3" style={{color: "#cccccc"}}>© 2023 envy - All Right Reserved</h6>
                <h6 className="set-smaller ps-3" style={{color: "#cccccc"}}>Tim Pengemebang IT Universitas Islam Ogan Komering Ilir.</h6>
            </div>
            
        </div>
        </>
    )
}

export default Footer;